/**
 * @generated SignedSource<<b94b7dc7b0ac3992cd51ace29cdc738a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityDatePicker_department$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentMaxGolfCourseBookingWindow_department">;
  readonly " $fragmentType": "DepartmentAvailabilityDatePicker_department";
};
export type DepartmentAvailabilityDatePicker_department$key = {
  readonly " $data"?: DepartmentAvailabilityDatePicker_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityDatePicker_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityDatePicker_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDepartmentMaxGolfCourseBookingWindow_department"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetClubStartOfWeekNumberPatron_club"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "a368bfdadb7980983688e87c31f11a77";

export default node;
